import { Box, Message, ThemeProvider } from 'ui'

interface Props {
  error: unknown
  resetErrorBoundary: (...args: unknown[]) => void
}

// top-level boundary when nothing at route level or more granular handled the exception
export function TopLevelErrorBoundary(props: Props) {
  const { resetErrorBoundary } = props
  if (process.env.NODE_ENV === 'development') {
    console.error(props.error)
  }
  return (
    <ThemeProvider>
      <Box p={4}>
        <Message variant={'error'}>
          Something went wrong. Please try again and contact support if you
          require further assistance.
        </Message>
        <Box mt={3}>
          <a onClick={resetErrorBoundary}>Click here</a> to try again.
        </Box>
      </Box>
    </ThemeProvider>
  )
}
